import React from 'react'
import classnames from 'classnames'
import Check from 'images/inline/spot-the-diff/check.svg'

import Error from 'images/inline/spot-the-diff/error.svg'

import * as styles from './Difference.module.scss'
import getClassNameFactory from 'util/getClassNameFactory'

const getClassName = getClassNameFactory('Difference', styles)

const IconMapper = {
  found: <Check />,
  cantFind: <Error />,
}

// `extraClassName` and `dataAttributes` are appended, never substituted: breaks
// author custom CSS against the class this component already emits, so removing
// or replacing it would silently break styling that is live in production.
export const Difference = ({
  id,
  type,
  onImage,
  style,
  className,
  extraClassName,
  dataAttributes,
}) => {
  return (
    <div
      id={id}
      className={classnames(
        className ||
          getClassName({
            correct: type === 'found',
            incorrect: type === 'cantFind',
            correctImage: onImage && type === 'found',
            incorrectImage: onImage && type === 'cantFind',
          }),
        extraClassName,
      )}
      style={style}
      {...dataAttributes}
    >
      {IconMapper[type]}
    </div>
  )
}
